import { FormContextValue } from '@sec-loans-ui/ifp-loans/types'
import { WizardStep } from '@sec-loans-ui/ifp-loans/wizard/wizardMachine'
import { User } from '@sec-loans-ui/wizard/types'
import { IfpApplicationState, IfpLoan } from '@shared/sec-loans'
import { createContext, use } from 'react'

export const FormContext = createContext<FormContextValue>({
  step: WizardStep.StatusStep,
  exit: () => Promise.resolve(),
  exitWithConfirmDialog: () => null,
  goBack: () => null,
  goBackToStatus: () => null,
  proceed: () => null,
  isStepSubmitting: false,
  hasSubmitFailed: false,
  loan: {} as IfpLoan,
  user: {} as User,
  applicationId: '',
  applicationState: IfpApplicationState.Draft,
  currentApplicantInfoIndex: 0,
  onEdit: () => null,
  onEditApplicantInfo: () => null,
  submit: () => null,
  showSendAbortPromptModal: () => null,
  showSendErrorModal: () => null,
  onCancelApplication: () => null,
  onReturnApplication: () => null,
  showSubmitErrorModal: () => null,
})

export const useIfpFormContext = () => {
  const context = use(FormContext)
  if (context === undefined) {
    throw new Error('useIfpFormContext must be used within a FormContext')
  }
  return context
}
